const exportMixin = {
  methods: {
    generateFileName(name = 'data') {
      const today = new Date();
      let datestring = '';
      datestring += today.getFullYear();
      datestring += (`0${today.getMonth() + 1}`).slice(-2);
      datestring += (`0${today.getDate()}`).slice(-2);
      datestring += (`0${today.getHours()}`).slice(-2);
      datestring += (`0${today.getMinutes()}`).slice(-2);

      return `${name}_${datestring}`;
    },
    downloadFile(blob, filename = 'data', extension = 'csv') {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filename}.${extension}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
  },
};

export default exportMixin;
